module.exports = __webpack_public_path__ + "static/media/logo-람다256@2x.19ffd21f.png";